// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"pJ-z","carouselContainer":"qJ-z"};